module.exports = __webpack_public_path__ + "img/plusv.31c28596.png";